import React, { useState, useEffect } from "react";
import axios from "axios";
import uuid from "react-uuid";

const ChangePIN = () => {
  const [npin, setNpin] = useState("");
  const [cpin, setCpin] = useState("");
  const [acno, setAcno] = useState("");
  const [acc, setAcc] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async () => {
    try {
      const res = await axios.get("http://localhost:5001/accounts");
      setAcno(res.data[0]?.account_number || "");
      setAcc(res.data);
    } catch (err) {
      setError("Failed to load accounts. Please try again.");
    }
  };

  const validate = () => {
    if (!acno) return "Please select an account.";
    if (!npin || !cpin) return "Please enter and confirm your new PIN.";
    if (!/^\d{4}$/.test(npin)) return "PIN must be exactly 4 digits.";
    if (npin !== cpin) return "PINs do not match.";
    return "";
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    setIsSubmitting(true);
    try {
      let data = {
        npin: npin,
        cpin: cpin,
        acc: acno,
      };
      await axios.post("http://localhost:5001/ChangePIN", { data });
      setMessage("PIN changed successfully!");
      setNpin("");
      setCpin("");
    } catch (err) {
      setError("Failed to change PIN. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="chngpin">
      <h2>Change Your PIN</h2>
      <p className="instructions">
        For your security, please choose a new 4-digit PIN. Make sure it is not easily guessable. Enter the same PIN in both fields to confirm.
      </p>
      <form name="ChangePIN" onSubmit={submitHandler} autoComplete="off">
        <div className="form-group">
          <label htmlFor="acc">Select Account</label>
          <select
            name="accounts"
            id="acc"
            value={acno}
            onChange={(e) => setAcno(e.target.value)}
            required
          >
            <option value="" disabled>
              -- select account --
            </option>
            {acc.map((acn) => (
              <option key={uuid()} value={acn.account_number}>
                {acn.account_number}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="npin">Enter New PIN</label>
          <input
            type="password"
            autoComplete="off"
            placeholder="New 4-digit PIN"
            id="npin"
            name="npin"
            value={npin}
            onChange={(e) => setNpin(e.target.value)}
            maxLength={4}
            pattern="\d{4}"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="cpin">Confirm New PIN</label>
          <input
            type="password"
            autoComplete="off"
            placeholder="Confirm new PIN"
            id="cpin"
            name="cpin"
            value={cpin}
            onChange={(e) => setCpin(e.target.value)}
            maxLength={4}
            pattern="\d{4}"
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        <button
          className="subButton"
          type="submit"
          disabled={isSubmitting || !!validate()}
        >
          {isSubmitting ? "Processing..." : "Proceed"}
        </button>
      </form>
    </div>
  );
};

export default ChangePIN;
